// frontend/src/components/eInvoicing/ProcessEInvoicingQueueButton.jsx
import React, { useState } from 'react';
import { toastSuccess, toastError, toastInfo } from '../../utils/toasts';

const ProcessEInvoicingQueueButton = () => {
  const [loading, setLoading] = useState(false);

  const handleProcessQueue = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem('token');
      if (!token) {
        alert('Session expirée');
        return;
      }

      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';

      const resp = await fetch(`${apiUrl}/api/e-invoicing/process-queue`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const data = await resp.json().catch(() => ({}));

      if (!resp.ok || !data.ok) {
        alert(
          data.error ||
            'Erreur lors du traitement de la file e-factures'
        );
        return;
      }

      if (data.message) {
        alert(data.message); // exemple: "Aucune facture en attente"
      } else {
        alert(
          `Facture de la file traitée. ID queue: ${data.queueItemId}, status: ${data.status}`
        );
      }
    } catch (e) {
      console.error('Erreur process-queue:', e);
      alert(e.message || 'Erreur lors du traitement de la file e-factures');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      className="btn btn-sm px-3 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition-colors"
      onClick={handleProcessQueue}
      disabled={loading}
      title="Traiter une facture signée en attente (XAdES + préparation TTN)"
    >
      {loading ? 'Traitement...' : 'Traiter la file e-factures'}
    </button>
  );
};

export default ProcessEInvoicingQueueButton;
